import { Link } from "@tanstack/react-router";
import { ChevronRightIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

/** The series page's View all sub-pages. */
type SeriesSubPagePath =
  | "/series/$series/episodes"
  | "/series/$series/cast"
  | "/series/$series/behind-the-scenes"
  | "/series/$series/recommendations";

/**
 * A section's heading on the series details page, with its View all link
 * when the section has a page of its own.
 */
const SectionHeader: React.FC<{
  title: string;
  viewAll?: {
    to: SeriesSubPagePath;
    series: string;
    testId: string;
    onClick?: () => void;
  };
}> = ({ title, viewAll }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-semibold text-white">{title}</h2>
      {viewAll && (
        <Link
          to={viewAll.to}
          params={{ series: viewAll.series }}
          className="flex items-center gap-1 text-sm text-white"
          data-test-id={viewAll.testId}
          onClick={viewAll.onClick}
        >
          {t("series_details_view_all_link_web")}
          <ChevronRightIcon className="size-4" />
        </Link>
      )}
    </div>
  );
};

export default SectionHeader;
